const C = {
  name: "ShoppingCart",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.38 0H0V2H2.38C2.85636 2 3.26145 2.3288 3.36256 2.7912L3.36282 2.79243L6.19149 16H21.7208L24 9.16228V5H5.88097L5.31783 2.37058L5.31718 2.36757C5.01784 0.990619 3.80322 0 2.38 0ZM7.80851 14L6.30931 7H10.1049L10.8827 14H7.80851ZM12.895 14L12.1173 7H15.8827L15.1049 14H12.895ZM17.895 7H22V8.83772L20.2792 14H17.1173L17.895 7Z" fill="currentColor"/>
<path d="M6 21C6 19.3477 7.34772 18 9 18C10.6523 18 12 19.3477 12 21C12 22.6523 10.6523 24 9 24C7.34772 24 6 22.6523 6 21ZM9 20C8.45228 20 8 20.4523 8 21C8 21.5477 8.45228 22 9 22C9.54772 22 10 21.5477 10 21C10 20.4523 9.54772 20 9 20Z" fill="currentColor"/>
<path d="M16 21C16 19.3477 17.3477 18 19 18C20.6523 18 22 19.3477 22 21C22 22.6523 20.6523 24 19 24C17.3477 24 16 22.6523 16 21ZM19 20C18.4523 20 18 20.4523 18 21C18 21.5477 18.4523 22 19 22C19.5477 22 20 21.5477 20 21C20 20.4523 19.5477 20 19 20Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as ShoppingCart
};
